/**
 * Custom hook to sync borrower business draft data with Redux store
 * Consolidates all Redux dispatch operations for borrower business data
 */

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { hydrateBizState } from "../../../features/merchant/biz";
import { Industry } from "../../../constants/enums";

export interface BorrowerBizDraftData {
  company: string;
  regNumber: string;
  legalStructure: string;
  industryGroup: string;
  industryDropdownValues: Industry[];
  industryOthers: string;
  typeOfInstitute: string;
  countryOfIncorp: string;
  countryOfDomicile: string;
  address: string;
  postal: string;
  website: string;
  phoneNumber: string;
  incorporationDate: string;
}

/**
 * Hook to sync borrower business draft data with Redux store
 * Uses hydrateBizState for efficient bulk updates
 */
export const useBorrowerBizDraftSync = () => {
  const dispatch = useDispatch();

  /**
   * Sync all borrower business data to Redux store
   * Uses hydrateBizState to update all fields in a single dispatch
   */
  const syncBorrowerBizToRedux = useCallback(
    (data: BorrowerBizDraftData) => {
      dispatch(hydrateBizState(data));
    },
    [dispatch]
  );

  return { syncBorrowerBizToRedux };
};
